import { useEffect } from 'react';
import { useDarkModeStore } from './useDarkModeStore';
import { useDimensions } from './useDimensions';
import { useTweakPane } from './useTweakPane';
import useUserGuideManager from './useUserGuideManager';

// only initialize once
let hasInitialized = false;

interface UseInitializeDataReturn {
  isDarkMode: boolean;
  isMobileOrPad: boolean;
  userGuideManager: ReturnType<typeof useUserGuideManager>;
  // isLoading: boolean;
}

const useInitializeData = (): UseInitializeDataReturn => {
  const { isDarkMode } = useDarkModeStore();
  const { isMobileOrPad } = useDimensions();
  useTweakPane();

  const userGuideManager = useUserGuideManager();
  useEffect(() => {
    if (!hasInitialized) {
      hasInitialized = true;
      // fetchProjectData();
    }
  }, []);
  return {
    isDarkMode,
    isMobileOrPad,
    userGuideManager,
    // isLoading,
  };
};

export default useInitializeData;
